import { cn } from '@/shared/lib';
import { forwardRef } from 'react';
import { useRTL } from '@/shared/hooks';
import {
  clearErrors,
  setNameError,
  setPhoneError,
  useAppDispatch,
  useAppSelector,
  CustomerTabsEnum,
  setSelectedCustomerTab,
} from '@/app/store';
import { useTranslation } from 'react-i18next';
import { Typography } from '@/shared/components';
import { useActualiseOrderPointBasket } from './hooks';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/shadcn';
import { BasketOrderPointPersonalInfo } from './BasketOrderPointPersonalInfo';

export const BasketOrderPoint = forwardRef<HTMLDivElement>((_, ref) => {
  const isRTL = useRTL();
  const dispatch = useAppDispatch();
  const selectedCustomerTab = useAppSelector((state) => state.orderAnotherPerson.selectedCustomerTab);
  const isOrderForAnotherPersonEnabled = useAppSelector(
    (state) => state.initial.settings.isOrderForAnotherPersonEnabled,
  );

  const { t } = useTranslation('basket');

  useActualiseOrderPointBasket(selectedCustomerTab === CustomerTabsEnum.Another);

  return (
    <div ref={ref} className='flex flex-col'>
      <Typography variant='h3' className={cn('mb-4', isRTL && 'text-right')}>
        {t('where.title')}
      </Typography>

      <Tabs
        value={selectedCustomerTab}
        dir={isRTL ? 'rtl' : 'ltr'}
        onValueChange={(v) => {
          dispatch(clearErrors(undefined));
          dispatch(setNameError(undefined));
          dispatch(setPhoneError(undefined));
          dispatch(setSelectedCustomerTab(v as CustomerTabsEnum));
        }}
        className='gap-0'
      >
        {isOrderForAnotherPersonEnabled && (
          <TabsList>
            <TabsTrigger value={CustomerTabsEnum.Myself}>{t('order.myself')}</TabsTrigger>

            <TabsTrigger value={CustomerTabsEnum.Another}>{t('order.another')}</TabsTrigger>
          </TabsList>
        )}

        <TabsContent value={CustomerTabsEnum.Myself} className={!isOrderForAnotherPersonEnabled ? 'mt-0' : ''}>
          <BasketOrderPointPersonalInfo />
        </TabsContent>

        <TabsContent value={CustomerTabsEnum.Another}>
          <BasketOrderPointPersonalInfo isOrderAnotherPerson />
        </TabsContent>
      </Tabs>
    </div>
  );
});
